import React, { createContext, useContext, useMemo } from "react";
import { useDispatch } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import PropTypes from "prop-types";

import ErrorPage from "../pages/Error";
import { actionToLog } from "../store/ducks/duckAudit";
import { useUser } from "../auth/UserProvider";

export const TELEMETRY_ENABLED = false;
const NOOP = () => {};
const NOOP_APP_INSIGHTS = {
  setAuthenticatedUserContext: NOOP,
  trackEvent: NOOP,
  trackPageView: NOOP,
  trackException: NOOP,
  flush: NOOP,
};

// Contexto para mantener compatibilidad con useAppInsights sin enviar telemetria
export const AppInsightsContext = createContext(NOOP_APP_INSIGHTS);

const AppInsightsProvider = (props) => {
  const { children } = props;
  const dispatch = useDispatch();
  const { email } = useUser();
  const appInsights = useMemo(() => NOOP_APP_INSIGHTS, []);

  if (email) {
    localStorage.setItem("Email", email);
  }

  const myErrorHandler = (error, info) => {
    const componentStack = info?.componentStack || "";
    const message = error?.message || "Unhandled React error";

    dispatch(
      actionToLog({
        action: "ERROR_BROWSER",
        details: `${message} ${componentStack}`.trim(),
      }),
    );
  };

  return (
    <AppInsightsContext.Provider value={appInsights}>
      <ErrorBoundary
        FallbackComponent={(errorProps) => <ErrorPage {...errorProps} />}
        onError={myErrorHandler}
      >
        {children}
      </ErrorBoundary>
    </AppInsightsContext.Provider>
  );
};

/**
 * @returns {object} appInsights-like no-op instance
 */
export const useAppInsights = () => useContext(AppInsightsContext);

AppInsightsProvider.propTypes = {
  children: PropTypes.node,
};

export default AppInsightsProvider;
